import {useMutation, useQueryClient} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {httpAcceptAssignment} from '@features/assignment/http/assignment.http'
import {Assignment} from '@features/assignment/types.ts'
import {errorHandler, raise} from '@utilities/helpers.ts'
import {captureException} from '@sentry/react'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {getTimezone} from '@/dates.ts'

export const useAcceptAssignment = (assignment?: Assignment) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (selectedDate?: string) =>
            parseAxiosPromise({
                axiosPromise: httpAcceptAssignment({
                    urlParams: {assignmentId: assignment?.id ?? raise('assignment is nullish')},
                    params: {
                        response_type: 'extended',
                        ...(selectedDate ? {selectedDate, timezone: getTimezone()} : {})
                    }
                }),
                responseShape: Assignment,
                onZodError: captureException
            }),
        onSuccess: data => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ASSIGNMENTS_REQUESTS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.CURRENT_ASSIGNMENTS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACTIVE_ASSIGNMENTS_RANGE]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACTIVE_ASSIGNMENTS_TABLE]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ASSIGNMENTS_COUNT]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.SPACES]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ASSIGNMENTS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.HOME_TABLE]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.REQUIRED_ACTIONS]})
            void queryClient.setQueriesData({queryKey: [QUERY_KEYS.ASSIGNMENT, assignment?.code]}, data)
        },
        onError: errorHandler
    })
}
